





















































import { Component, Vue } from 'nuxt-property-decorator'
import { RxFormBuilder, IFormGroup } from '@rxweb/reactive-forms'
import { $axios } from '~/utils/api'
import Spinner from '~/components/shared/Spinner.vue'
import Button from '~/components/shared/Button.vue'
import Input from '~/components/shared/inputs/Input.vue'
import routes from '~/constants/routerPath.js'
import { ResetPasswordRequestForm } from '~/models/forms'
import { InputType } from '~/enums/inputType'

@Component({
  layout: 'public',
  components: {
    Spinner,
    Button,
    Input,
  },
})
export default class PasswordReset extends Vue {
  inputType: typeof InputType = InputType
  routerpath: any = routes
  userNameDefaultText = 'Your email address. e.g. name@company.com'
  errorText: string | null = null
  loading = false

  resetFormGroup!: IFormGroup<ResetPasswordRequestForm>
  formBuilder: RxFormBuilder = new RxFormBuilder()

  constructor() {
    super()
    this.resetFormGroup = this.formBuilder.formGroup(
      ResetPasswordRequestForm
    ) as IFormGroup<ResetPasswordRequestForm>
  }

  get currentYear() {
    return new Date().getFullYear()
  }

  async submitWithEnter(event: any) {
    if (event.code === 'Enter') {
      await this.submitForm()
    }
  }

  get inputText(): string {
    if (this.errorText) {
      return this.errorText
    }
    return this.userNameDefaultText
  }

  get baseUrl(): string {
    return $axios.defaults.baseURL
  }

  async submitForm(): Promise<void> {
    if (this.resetFormGroup.valid) {
      try {
        this.loading = true
        const email: any = this.resetFormGroup.value
        await $axios.post('reset_password', email)
        this.$router.push(routes.passwordResetDone)
      } catch (err) {
        this.loading = false
        this.$router.push(routes.passwordResetDone)
      }
    } else {
      this.resetFormGroup.controls.email.markAsDirty()
    }
  }
}
